import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const AlipayPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.ALIPAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.ALIPAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.ALIPAY)} alt="alipay" />
    </Box>
  );
};
